import React from "react";

import { GameInformationTechnicalCapabilitiesDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ApplicationInformationTechnicalCapabilitiesProps = {
  dataInForm: GameInformationTechnicalCapabilitiesDataType;
};

const getCapabilitiesList = (
  translatedStringsMap: Map<string, string>,
  capabilities: { capability: string; selected: boolean; details: string }[]
) =>
  capabilities
    .filter(value => value.selected === true)
    .map(element => translatedStringsMap.get(element.capability));

const getCapabilityDetails = (
  capability: string,
  capabilities: { capability: string; selected: boolean; details: string }[]
) =>
  capabilities
    .filter(value => value.selected === true && value.capability === capability)
    .map(element => element.details);

const IdXboxXboxNetworkConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "anticipatedCapabilities",
    {
      mapper: (
        data: GameInformationTechnicalCapabilitiesDataType,
        localizedStrings: Map<string, string>
      ) => getCapabilitiesList(localizedStrings, data.anticipatedCapabilities),
    },
  ],
  [
    "targetNative4k",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("targetNative4k", data.anticipatedCapabilities),
    },
  ],
  [
    "crossGenerationalContent",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("crossGenerationalContent", data.anticipatedCapabilities),
    },
  ],
  [
    "cloudAware",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("cloudAware", data.anticipatedCapabilities),
    },
  ],
  [
    "xboxSeriesXSVersionCapabilities",
    {
      title: "anticipatedXboxSeriesXSCapabilities",
      mapper: (
        data: GameInformationTechnicalCapabilitiesDataType,
        localizedStrings: Map<string, string>
      ) => getCapabilitiesList(localizedStrings, data.xboxSeriesXSVersionCapabilities),
    },
  ],
  [
    "rayTracing",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("rayTracing", data.xboxSeriesXSVersionCapabilities),
    },
  ],
  [
    "highFrameRate",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("highFrameRate", data.xboxSeriesXSVersionCapabilities),
    },
  ],
  [
    "directStorage",
    {
      mapper: (data: GameInformationTechnicalCapabilitiesDataType) =>
        getCapabilityDetails("directStorage", data.xboxSeriesXSVersionCapabilities),
    },
  ],
  [
    "xboxSeriesXSAdvantage",
    {
      title: "seriesXSAdvantageTitle",
    },
  ],
]);

export const ReadOnlyIdXboxTechnicalCapabilities = ({
  dataInForm,
}: ApplicationInformationTechnicalCapabilitiesProps) => {
  const extraStringsToLocalize = ["allPlatforms", "hdr"];

  return (
    <ReadOnlyForm
      formConfig={IdXboxXboxNetworkConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
